import {
  BETWEEN_SEPARATOR,
  IN_SEPARATOR,
} from '@/shared/filters/filter-builder.constants';
import { isValidDate } from '@/shared/filters/utils/is-valid-date';

export const getFilterMethod = (filterValue: string) => {
  if (filterValue.includes(BETWEEN_SEPARATOR)) {
    const splitValue = filterValue.split(BETWEEN_SEPARATOR)[0];

    if (isValidDate(splitValue)) {
      return 'between';
    }
  }

  return filterValue.includes(IN_SEPARATOR) ? 'in' : 'contains';
};
